import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { formatTime } from '@doltech/utils/lib/date';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import Timer from 'react-compound-timer';
import styled from 'styled-components';

import { useTestSubmissionStore } from '../../model/test-submissions.hook';
import { TimeLimitSharedLayout } from './TimeLimitSharedLayout';

export const ReadingTimeLimit = observer(() => {
  const testSubmissionStore = useTestSubmissionStore();
  const {
    id,
    openTimeUpModal,
    setRemainTimeInSeconds,
    totalDuration,
    inProgressTotalDurationInSeconds,
    isStartedTest,
  } = testSubmissionStore;
  const startedTimeInMilliseconds = inProgressTotalDurationInSeconds * 1000;
  const uuid = `${id}_${isStartedTest}`;
  return (
    <ReadingTimeLimitSharedLayout
      uuid={uuid}
      duration={totalDuration}
      startedTimeInMilliseconds={startedTimeInMilliseconds}
      startImmediately={isStartedTest}
      onTimeUp={() => {
        openTimeUpModal();
      }}
      onProgress={setRemainTimeInSeconds}
      className="reading-test-timer"
    >
      <Timer
        key={uuid}
        initialTime={startedTimeInMilliseconds}
        lastUnit="m"
        direction="backward"
        timeToUpdate={1000}
        startImmediately={isStartedTest}
      >
        <Typography.Text variant="semi-bold/16" color="gray180">
          <Timer.Minutes formatValue={formatTime} />
          :
          <Timer.Seconds formatValue={formatTime} />
        </Typography.Text>
      </Timer>
    </ReadingTimeLimitSharedLayout>
  );
});

const ReadingTimeLimitSharedLayout = styled(TimeLimitSharedLayout)``;
